import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const UserX = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.393 18.964v-1.071a3.214 3.214 0 0 1 3.214-3.214h4.286a3.214 3.214 0 0 1 3.214 3.214v1.071m8.02-10.428-2.25 2.25m0 0-2.25 2.25m2.25-2.25-2.25-2.25m2.25 2.25 2.25 2.25M10.963 8.25a3.214 3.214 0 1 1-6.428 0 3.214 3.214 0 0 1 6.428 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(UserX) as SvgIcon;
export { ForwardRef as ReactComponent };
